import { lazy } from "react";
import { blogPostsLoader, blogPostLoader } from "./blogLoader";

const BlogPostList = lazy(() => import("../../../pages/Blog"));
const BlogPost = lazy(() => import("../../../pages/BlogPost"));
import ErrorPage from "../../../components/UI/ErrorPage";

export const blogRoutes = [
  {
    path: "insights",
    element: <BlogPostList />,
    loader: blogPostsLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "/insights/post/:id",
    element: <BlogPost />,
    loader: blogPostLoader,
    errorElement: <ErrorPage />,
  },
];
